import { TaxiCompanyList } from "../../../../services/taxi/GetDirectionAndFare/models/getFareSamplesParams";
import { Lang } from "../../../../states/query";
import { getNowLuxonDateTime, setBaseDay } from "../../../../utils/luxonUtil";

export class CommonTaxiUtils {
  limit_days:  number;
  limit_hours: number;
  company:     TaxiCompanyList;
  targetAirport: string;
  constructor(limit_days: number, limit_hours: number, company: TaxiCompanyList, targetAirport: string) {
    this.limit_days = limit_days;
    this.limit_hours = limit_hours;
    this.company = company;
    this.targetAirport = targetAirport;
  }

  /**
   * 仮予約画面で予約受付期間外を選んだ際に表示するメッセージ
   * @param originErrorMessage バックエンドから取得した表示するメッセージ
   */
  getErrorMessage(originErrorMessage: string, lang: Lang): string {
    if(this.isLimoTaxiTYO()) {
      if(lang === Lang.ja) {
        return '乗車日時は2日後以降を指定してください。'
      }
      else {
        return 'Please specify a ride date and time from two days’ time on.';
      }
    }
    else {
      return originErrorMessage;
    }
  }

  /**
   * limoTaxiかつHNDかNRTの時には予約受付締切を2日前に設定する
   * この例外設定を適用するか判定する
   * @param targetAirport 搭乗対象の空港コード
   */
  isLimoTaxiTYO() {
    const isLimoTaxi = (this.company === TaxiCompanyList.limoTaxi);
    const isTYO = ['HND', 'NRT', 'TYO'].includes(this.targetAirport);
    return isLimoTaxi && isTYO;
  }

  /**
   * 現在時刻がイースタンタクシーが予約可能期限内であるかを判別する。
   * TODO: isAvalableに統合する
   * @param ridingDate 乗車日
   */
  isAvalableEastern(ridingDate: luxon.DateTime): boolean {
    // そのまま differenceInDays を使うと 23:59と 00:01 の差は0になるので、分と秒は0に一旦揃える
    const rideingDateBase = setBaseDay(ridingDate);
    const nowDateBase = setBaseDay(getNowLuxonDateTime());
    // limotaxiの場合かつ、羽田・成田の場合には2日前までに予約すればよい
    const limitDays = this.isLimoTaxiTYO() ? 1: this.limit_days;
    /** 不正な乗車日時である（現在日時のX日後以前）かを表すフラグ。 */
    return rideingDateBase.diff(nowDateBase, 'days').days > limitDays;
  }

  /**
   * 現在時刻がタクシーが予約可能期限内であるかを判別する。
   * @param flightDate 搭乗日の日時。
   * @param targetAirport 搭乗対象の空港コード
   */
  isAvalable(flightDate: luxon.DateTime): boolean {
    /** イースタンだけロジックが違うのでこちらにて対応 */
    if(this.company === TaxiCompanyList.eastern || this.company === TaxiCompanyList.limoTaxi) {
      return this.isAvalableEastern(flightDate);
    }
    /** タクシーの予約期限の日付。 */
    const deadlineDate = setBaseDay(
        flightDate.minus({
        day: this.limit_days
      })
    ).set({
      hour: this.limit_hours
    })
    // 搭乗日のX日前のXX時より前である場合のみ、予約可能とする。
    return getNowLuxonDateTime() < deadlineDate;
  }

  /**
   * 現在時刻がタクシーを予約できない日付の場合、予約できる代替の日付を返す
   * @param flightDate 搭乗日の日時。
   * @param nowDate 端末の現在時刻
   * @return 代替の日付
   */
  getAvailableDate(flightDate: luxon.DateTime): luxon.DateTime {
    /** イースタンだけロジックが違うのでこちらにて対応 */
    if(this.company === TaxiCompanyList.eastern || this.company === TaxiCompanyList.limoTaxi) {
      if(this.company === TaxiCompanyList.eastern || this.isLimoTaxiTYO()) {
        return getNowLuxonDateTime().plus({
          day: 2
        });
      }
      else {
        return getNowLuxonDateTime().plus({
          day: 4
        })
      }
    }
    if(this.isAvalable(flightDate)) {
      return flightDate;
    }
    else {
      if(getNowLuxonDateTime().hour >= this.limit_hours) {
        return getNowLuxonDateTime().plus({
          days: (this.limit_days + 1)
        })
      }
      else {
        return getNowLuxonDateTime().plus({
          days: this.limit_days
        })
      }
    }
  }
}
